// extracted by mini-css-extract-plugin
export default {"root":"Button_root__vswH3","primary":"Button_primary__9MLUH","grey":"Button_grey__ZqTlR"};